import {
  getErrorCode,
  getErrorResponse,
  getErrorStatus,
  SERVICE_UNAVAILABLE_TEXT,
} from '../../../../../common/api/errors'

const FALLBACK_ERROR = 'Не удалось загрузить логи риск-баллов'

const FIELD_LABELS: Record<string, string> = {
  externalUserId: 'ID клиента',
  externalUserToken: 'Токен клиента',
  dateStart: 'Дата с',
  dateEnd: 'Дата по',
}

/** Понятный текст вместо технического ответа бэкенда — по полю, а не по его сообщению. */
const FIELD_MESSAGES: Record<string, string> = {
  externalUserId: 'ID клиента указан неверно: пустое значение недопустимо.',
  externalUserToken:
    'Токен клиента указан неверно: ожидается UUID из 36 символов, например a2d9533f-fe1a-5c69-bd5d-7fbff8b0eb47.',
}

/** Text of a refused risk-score log load: a token that is not a client token reads by its code. */
export const riskScoreLogsErrorText = (error: unknown): string => {
  if (getErrorCode(error) === 'EXTERNAL_USER_TOKEN_INVALID') {
    return FIELD_MESSAGES.externalUserToken
  }

  const status = getErrorStatus(error)
  if (status === 404) {
    return 'Клиент с таким токеном не найден.'
  }
  if (status === 503) {
    return SERVICE_UNAVAILABLE_TEXT
  }
  if (status !== undefined && status >= 500) {
    return FALLBACK_ERROR
  }

  const errors = getErrorResponse<Record<string, unknown>>(error)
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) {
    return FALLBACK_ERROR
  }

  const [field] = Object.keys(errors)
  if (!field) {
    return FALLBACK_ERROR
  }

  if (FIELD_MESSAGES[field]) {
    return FIELD_MESSAGES[field]
  }

  if (field === 'general_error') {
    return String(errors[field])
  }

  return `${FIELD_LABELS[field] ?? field}: ${errors[field]}`
}
